<div>
  <div id="renderComponent"></div>
  <button *ngIf="!isOpen" (click)="handleOpen()">Open</button>
</div>
